import React from 'react'
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom'
import AuthLayout from './hoc/layouts/AuthLayout'
import SignIn from './containers/Auth/SignIn/SignIn'
import GlobalCssOverride from './globalTheme'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import MainLayout from './hoc/layouts/MainLayout'
import ScrollToTop from './hoc/ScrollToTop'
import Properties from './containers/Properties/Properties'
import PropertySummary from './containers/Properties/PropertySummary'
import JobSummary from './containers/JobSummary/JobSummary'
import Appliance from './containers/Appliance/Appliance'
import Instructions from './containers/Instructions/Instructions'
import Reports from './containers/Reports/Reports'
import AssertReports from './containers/Reports/AssertReports'
import ServiceExpiryReports from './containers/Reports/ServiceExpiryReports'
import Admin from './containers/Admin/Admin'
import AddNewUser from './containers/Admin/AddNewUser'
import ManageUsers from './containers/ManageUsers/ManageUsers'

const theme = createMuiTheme({
  typography: {
    fontFamily: ['Lato', 'sans-serif'].join(',')
  }
})

const App = () => {
  const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  )

  let routes = (
    <BrowserRouter>
      <ScrollToTop />
      <Switch>
        <AppRoute path="/signin" component={SignIn} layout={AuthLayout} />
        <AppRoute
          path="/properties"
          component={Properties}
          layout={MainLayout}
        />
        <AppRoute
          key={'/property/:id'}
          exact
          path="/property/:id"
          component={PropertySummary}
          layout={MainLayout}
        />
        <AppRoute
          key={'/property/:propertyId/appliance/:id'}
          exact
          path="/property/:propertyId/appliance/:id"
          component={Appliance}
          layout={MainLayout}
        />
        <AppRoute path="/reports" component={Reports} layout={MainLayout} />
        <AppRoute
          path="/assert-reports"
          component={AssertReports}
          layout={MainLayout}
        />
        <AppRoute
          path="/service-expiry-reports"
          component={ServiceExpiryReports}
          layout={MainLayout}
        />
        {/* <AppRoute path="/jobs" component={Jobs} layout={MainLayout} /> */}
        <AppRoute
          key={'/job/:id'}
          exact
          path="/job/:id"
          component={JobSummary}
          layout={MainLayout}
        />
        <AppRoute
          key={'/job/:jobId/instruction/:id'}
          exact
          path="/job/:jobId/instruction/:id"
          component={Instructions}
          layout={MainLayout}
        />
        <AppRoute
          path="/admin"
          component={Admin}
          exact
          key="/admin"
          layout={MainLayout}
        />
        <AppRoute
          key={'/admin/add-new-user'}
          path="/admin/add-new-user"
          exact
          component={AddNewUser}
          layout={MainLayout}
        />
        <AppRoute
          key={'/admin/:userId'}
          path="/admin/:userId"
          exact
          component={ManageUsers}
          layout={MainLayout}
        />
        <Redirect from="/" to="/properties" />
        <AppRoute path="*">
          <AppRoute to="/" />
        </AppRoute>
      </Switch>
    </BrowserRouter>
  )

  return (
    <ThemeProvider theme={theme}>
      <div>
        {GlobalCssOverride()}
        {routes}
      </div>
    </ThemeProvider>
  )
}

export default App
